module.exports = __webpack_public_path__ + "media/placeholder-desktop-d91a19ab.jpg";